import { useContext, type ReactNode } from "react";
import { AuthContext } from "../../shared/Contexts/Auth/AuthContext";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  element: ReactNode;
  redirectTo: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  redirectTo,
}) => {
  const { isLoggedIn } = useContext(AuthContext);

  return isLoggedIn ? <>{element}</> : <Navigate to={redirectTo} />;
};

export default ProtectedRoute;
